<app-container
	[collapsable]="collapsable"
	[(collapsed)]="collapsed"
	[border]="collapsable ? highlightOnExpand : true"
	[titleTemplate]="titleTemplate"
	[highlightOnExpand]="highlightOnExpand"
>
	<hr [ngClass]="{ 'border-white': collapsable }" />

	<div class="pl-5 p-2">
		<div class="" *ngIf="client?.serviceAddress">
			<app-icon [icon]="ICON.LOCATION" class="text-grey-light mr-3"></app-icon>
			<span class="text-sm">{{ client?.serviceAddress | address }}</span>
		</div>

		<p class="my-2 font-bold">Contact details</p>
		<app-contact-details-card
			[contactDetails]="{ phone: client?.phone, email: client?.email }"
			(edit)="goToGlobalProfile(client.id)"
		>
		</app-contact-details-card>
	</div>
</app-container>

<ng-template #titleTemplate>
	<div
		(click)="toggleCollapsed()"
		class="p-2 cursor-pointer border border-grey-veryLight rounded"
		[ngClass]="{
			'hover:border-blue-lightest hover:bg-blue-lightest': collapsable
				? collapsed
				: false,
			'border-none': highlightOnExpand ? !collapsed : false,
			'border-t border-b-0 border-l-0 border-r-0 cursor-default': !collapsable,
		}"
	>
		<div class="flex justify-between">
			<div class="flex items-center">
				<atomic-name-badge
					size="small"
					[firstName]="$any(client)?.firstName"
					[lastName]="$any(client)?.lastName"
					[icon]="$any(client)?.name ? ICON.BUSINESS : null"
				></atomic-name-badge>

				<div class="flex flex-col justify-items-start ml-5">
					<h5 class="mb-0 font-semibold">{{ client | clientName }}</h5>
					<div *ngIf="primary">
						<app-pill class="mt-2" mode="secondary" size="xsmall"
							>Primary lender</app-pill
						>
					</div>
				</div>
			</div>
			<div class="flex items-center">
				<app-icon
					*ngIf="collapsable"
					class="mx-2 cursor-pointer"
					[icon]="collapsed ? ICON.DOWN : ICON.UP"
				></app-icon>
				<atomic-kebab-options
					*ngIf="!hideKebab"
					(click)="$event.stopPropagation()"
					[itemGroups]="[{ items: AssociationClientKebabOptions }]"
					(onSelect)="onKebabSelect(client.id, $event)"
				>
				</atomic-kebab-options>
			</div>
		</div>
	</div>
</ng-template>
